import React, { useEffect, useState } from "react";
import { Modal, OverlayTrigger, Tooltip } from "react-bootstrap";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import {
  sortCaret,
  headerSortingClasses,
  PleaseWaitMessage,
  NoRecordsFoundMessage,
  toAbsoluteUrl,
} from "../../../../_metronic/_helpers";

import { useDispatch, useSelector } from "react-redux";

import { useHistory } from "react-router-dom";
import {
  sizePerPageList,
  showSuccessDialog,
  showErrorDialog,
  activeFormatter,
  showConfirmDialog,
  formatDate,
  lockedFormatter,
  showDeleteDialog,
  checkPermision,
  iconError,
  formatterStatus,
} from "../../../utility";
import SVG from "react-inlinesvg";

import { isDateFormat, parseDateString } from "../../../utility";
import moment from "moment";

export const ReportTable = ({
  data,
  page,
  sizePerPage,
  sortField,
  sortOrder,
  onTableChange,
  totalSize,
  loading,
  handleSearch,
}) => {
  const dispatch = useDispatch();
  const history = useHistory();

  useEffect(() => {
    // Add number
    const pageBefore = sizePerPage * (page - 1);
    const initData = data.map((item, index) => {
      return {
        no: index + 1 + pageBefore,
        ...item,
      };
    });
    setTableData(initData);
  }, [data, sizePerPage, page]);

  const [tableData, setTableData] = useState([]);
  const columns = [
    {
      text: "No.",
      dataField: "no",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      // style: { minWidth: "150px" },  
    },
    {
      text: "VIN No.",
      dataField: "VIN_No",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "ID No.",
      dataField: "D_No",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "MP CONTROL No.",
      dataField: "inbound_name",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "INBOUND",
      dataField: "inbound",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "OUTBOUND",
      dataField: "outbound",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    // {
    //   text: "Master Code",
    //   dataField: "Master_Code",
    //   sort: true,
    //   sortCaret: sortCaret,
    //   headerSortingClasses,
    //   style: { minWidth: "150px" },
    // },
    {
      text: "VEHICLE NAME",
      dataField: "Vehicle_Name",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "MP CODE (CURRENT)",
      dataField: "MP_Code",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "100px" },
    },
    {
      text: "MP NAME (CURRENT)",
      dataField: "MP_Name",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "VEHICLE STATUS",
      dataField: "Vehicle_Status",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "IRREGULAR STATUS",
      dataField: "Irregular_Status",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "ESTIMATED DATE / MP-IN",
      dataField: "Estimated_Date / MP_In",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
      formatter: formatDate,
    },
    {
      text: "ACTUAL DATE / MP-IN",
      dataField: "Actual_Date / MP_In",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
      formatter: formatDate,
    },
    {
      text: "ETD MP",
      dataField: "Etd_Mp",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
      formatter: formatDate,
    },
    {
      text: "ATD MP",
      dataField: "Atd_Mp",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
      formatter: formatDate,
    },
    {
      text: "ETA DEALER",
      dataField: "Eta_Dealer",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
      formatter: formatDate,
    },
    {
      text: "ATA DEALER",
      dataField: "Ata_Dealer",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
      formatter: formatDate,
    },

    {
      text: "ETA PORT OF LOADING",
      dataField: "Eta_Port_Of_Loading",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
      formatter: formatDate,
    },
    {
      text: "ATA PORT OF LOADING",
      dataField: "Ata_Port_Of_Loading",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
      formatter: formatDate,
    },
    {
      text: "FACTORY NAME",
      dataField: "Factory_Name",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "OWNER NAME",
      dataField: "Client_Name",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "PRODUCTION CONFIRM",
      dataField: "Production_Confirm",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "LOT No.",
      dataField: "Lot_No",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "CAR No.(1)",
      dataField: "Car_No.(1)",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "CAR No.(2)",
      dataField: "Car_No.(2)",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "MODEL YEAR",
      dataField: "Model_Year",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "Model Code",
      dataField: "Model_Code",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "MODEL NAME",
      dataField: "Model_Name",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "EXTERIOR CODE",
      dataField: "Exterior_Code",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "INTERIOR CODE",
      dataField: "Interior_Code",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "OPTION CODE",
      dataField: "Option_Code",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "EXTERIOR NAME",
      dataField: "Exterior_Name",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "INTERIOR NAME",
      dataField: "Interior_Name",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "ENGINE No.",
      dataField: "Engine_No",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "KEY No.",
      dataField: "Key_No",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },

    {
      text: "PRODUCTION DATE",
      dataField: "Production_Date",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
      formatter: formatDate
    },
    {
      text: "WEIGHT",
      dataField: "WEIGHT",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "M3",
      dataField: "M3",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "LENGTH",
      dataField: "LENGTH",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "WIDE",
      dataField: "WIDTH",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "HEIGHT",
      dataField: "HEIGHT",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "MP PROCESS (CURRENT)",
      dataField: "Mp_Process",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "NO OF MP PROCESS (TOTAL)",
      dataField: "No_Of_Mp_Process",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "N/O PROC (COMP)",
      dataField: "N / O_Proc_(Comp)",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "MP CODE (RECEIVED)",
      dataField: "Mp_Code_Recived",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "MP NAME  (RECEIVED)",
      dataField: "Mp_Name_Recived",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "OWNERSHIP",
      dataField: "OWNERSHIP",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "TRANSFER",
      dataField: "TRANSFER",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "MP CODE (TRANSFER)",
      dataField: "Mp_Code_Recived_Consigne",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "MP NAME (TRANSFER)",
      dataField: "Mp_Name_Recived_Consigne",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "NO OF TRANSFER",
      dataField: "No_Of_Transfer",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "STOCK LOCATION (STORAGE)",
      dataField: "Stock_Location_Storage",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "STOCK LOCATION (RESERVED)",
      dataField: "Stock_Location_Reserved",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "H1",
      dataField: "H1",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "H2",
      dataField: "H2",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "H3",
      dataField: "H3",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "H4",
      dataField: "H4",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "STANDBY LANE (1)",
      dataField: "Standby_Line1",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "STANDBY LANE (2)",
      dataField: "Standby_Line2",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "WASH CAR",
      dataField: "Wash_Car",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "FUEL",
      dataField: "Fuel",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "ODOMETER (INITIAL)",
      dataField: "Odometer(Initial)",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "ODOMETER (UPDATE)",
      dataField: "Odometer(Update)",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "ORDER COMPLETED",
      dataField: "Order_Completed",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "RETURN TO FACTORY",
      dataField: "Return_To_Factory",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "CANCEL (DISPATCH)",
      dataField: "Cancel(Dispatch)",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "CANCEL (TRANSFER)",
      dataField: "Cancel(Transfer)",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "DATA EXTRACT",
      dataField: "Data_Extract",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "INVENTORY COUNT DATE",
      dataField: "Inventory_Count_Date",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
      formatter: formatDate,
    },
    {
      text: "MP CODE (INVENTORY COUNT)",
      dataField: "Mp_Code(Inventory_Count)",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "MP NAME  (INVENTORY COUNT)",
      dataField: "Mp_Name(Inventory_Count)",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "STK LOCA (INVENTORY)",
      dataField: "Stk_Loca(Inventory)",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "SALES ORDER / DELIVERY ORDER",
      dataField: "Sales_Order / Delivery_Order",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "ORDER CONFIRM",
      dataField: "Order_Confirm",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "ORDER DATE",
      dataField: "Order_Date",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
      formatter: formatDate,
    },
    {
      text: "ORDER VOLUME",
      dataField: "Order_Volume_Outbound",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "PIC",
      dataField: "Pic_Useless",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "INVOICE NUMBER",
      dataField: "Invoice_Number1",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "INVOICE DATE",
      dataField: "Invoice_Date1",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
      formatter: formatDate,
    },
    {
      text: "DEALER CODE",
      dataField: "Dealer_Code",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "DEALER NAME",
      dataField: "Dealer_Name",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "ADDRESS (DEALER)",
      dataField: "Address(Dealer)",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "PERSON IN CHARGE (DEALER)",
      dataField: "Person_In_Charge",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "CONTACT INFORMATION (DEALER)",
      dataField: "Contact_In_Information",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "DESTINATION CODE",
      dataField: "Destination_Code",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "DESTINATION NAME",
      dataField: "Destination_Name",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "ADDRESS (DESTINATION)",
      dataField: "Address(Destination)",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "REGION GROUP (DESTINATION)",
      dataField: "Region_Group",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "REGION (DESTINATION)",
      dataField: "Region",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "CITY (DESTINATION)",
      dataField: "Address(City)",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "LEAD TIME (DESTINATION)",
      dataField: "Lead_Time_Destination",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "PIC",
      dataField: "Pic_Useless2",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "INFO (DEST)",
      dataField: "Info_Dest",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "PRIORITY (SHIPMENT)",
      dataField: "Priority_Shipment",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "REQUEST ETD MP",
      dataField: "Request_Etd_Mp",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    // cek format date
    {
      text: "REQUEST ETA DEALER",
      dataField: "Request_Eta_Dealer",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "DO CHANGE",
      dataField: "Do_Change",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "ORDER CANCEL",
      dataField: "Order_Cancel1",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "NO OF CHANGES",
      dataField: "No_Of_Changes1",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "SHIPMENT ORDER",
      dataField: "Shipment_Order",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "ORDER CONFIRM",
      dataField: "Order_Confirmation_Outbound",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "ORDER STATUS",
      dataField: "Order_Status",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },

    {
      text: "ORDER DATE",
      dataField: "Order_Date_Outbound",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
      formatter: formatDate,
    },
    {
      text: "ORDER VOLUME",
      dataField: "Order_Volume",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "PIC",
      dataField: "Pic_Outbound_Create",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    // {
    //   text: "No Of Changes",
    //   dataField: "No_Of_Changes2",
    //   sort: true,
    //   sortCaret: sortCaret,
    //   headerSortingClasses,
    //   style: { minWidth: "150px" },
    // },
    {
      text: "INVOICE NUMBER",
      dataField: "Invoice_Number2",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "INVOICE DATE",
      dataField: "Invoice_Date2",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "DELIVERY MODE",
      dataField: "Delivery_Mode1",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "DELIVERY MIX",
      dataField: "Delivery_Mix1",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "DESTINATION SEQUENCE",
      dataField: "Destination_Sequence1",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "REQUEST CARRIER CAR SIZE",
      dataField: "REQUEST_CARRIER_CAR_SIZE1",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "CARRIER CAR SIZE",
      dataField: "CARRIER_CAR_SIZE1",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "CARRIER CODE",
      dataField: "Carrier_Code_Outbound",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "CARRIER NAME",
      dataField: "Carrier_Name_Outbound",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "TRAILER No.",
      dataField: "Trailer_No",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "DRIVER NAME",
      dataField: "Driver_Name",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "CONTACT INFORMATION (DRIVER)",
      dataField: "Contact_Information_Driver",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "EST / D-RECEIVE",
      dataField: "Est_D_Receive",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "EST / D-RECEIVE(TZ)",
      dataField: "Est_D_Receive_Tz",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "ORDER CANCEL",
      dataField: "Order_Cancel2",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "NUNBER OF CHANGES",
      dataField: "Number_Of_Changes",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "TRANSFER DERIVERY ORDER",
      dataField: "Transfer_Delivery_Order",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "ORDER CONFIRM (TO)",
      dataField: "Order_Confirm_To",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "ORDER STATUS (TO)",
      dataField: "Order_Status_To",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "ORDER DATE (TO)",
      dataField: "Order_Date_To",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "ORDER VOLUME (TO)",
      dataField: "Order_Volume_To",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "PERSON IN CHARGE (ORDER INPUT)",
      dataField: "Person_In_Charge_Order_Input",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "INVOICE NUMBER (TO)",
      dataField: "Invoice_Number_To",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "INVOICE DATE (TO)",
      dataField: "Invoice_Date_To",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "DELIVERY MODE",
      dataField: "Delivery_Mode2",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "DELIVERY MIX",
      dataField: "Delivery_Mix2",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "DESTINATION SEQUENCE",
      dataField: "Destination_Sequence2",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "REQUEST CARRIER CAR SIZE",
      dataField: "Request_Carrier_Car_Size2",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "CARRIER CAR SIZE",
      dataField: "Carrier_Car_Size2",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "CARRIER CODE",
      dataField: "Carrier_Code",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "CARRIER NAME",
      dataField: "Carrier_Name",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "TRAILER No.",
      dataField: "Trailer_No_2",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "DRIVER NAME",
      dataField: "Driver_Name_2",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "CONTACT INFORMATION (DRIVER)",
      dataField: "Contact_Information_Driver_2",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "EST / D-RECEIVE",
      dataField: "Est_D_Receive_2",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "EST / D-RECEIVE(TZ)",
      dataField: "Est_D_Receive_Tz_2",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "ORDER CANCEL (TO)",
      dataField: "Order_Cancel_To",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "NO OF CHANGES (TO)",
      dataField: "Number_Of_Changes_To",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "SHIPPING INSTRUCTION",
      dataField: "Shipping_Instruction",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "ORDER CONFIRM (SI)",
      dataField: "Order_Confirm_Si",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "ORDER DATE (SI)",
      dataField: "Order_Date_Si",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "ORDER VOLUME (SI)",
      dataField: "Order_Volume_Si",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "PIC",
      dataField: "Pic",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "B/L NUMBER",
      dataField: "B_L_Number",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "B/L DATE",
      dataField: "B_L_Date",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "VOLUME (B/L)",
      dataField: "Volume_B_L",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "INVOICE NUMBER (SI)",
      dataField: "Invoice_Number_Si",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "INVOICE DATE (SI)",
      dataField: "Invoice_Date_Si",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "DESTINATION COUNTRY CODE",
      dataField: "Destination_Country_Code",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "DESTINATION COUNTRY NAME",
      dataField: "Destination_Country_Name",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "PORT OF LOADING (SI)",
      dataField: "Port_Of_Loading_Si",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "PORT OF DISCHARGE",
      dataField: "Port_Of_Discharge1",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "SHIPPING COMPANY (SI)",
      dataField: "Shipping_Company_Si",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "VESSEL NAME (SI)",
      dataField: "Vessel_Name_Si",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "VOY No.",
      dataField: "Voy_Number",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "YARD CUT DATE",
      dataField: "Yard_Cut_Date",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "EST / GATE IN (SI)",
      dataField: "Est_Gate_In_Si",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "ETD POL (SI)",
      dataField: "Etd_Pol_Si",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "ATD POL (SI)",
      dataField: "Atd_Pol_Si",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "ORDER CANCEL (SI)",
      dataField: "Order_Cancel_Si",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "NO OF CHANGES (SI)",
      dataField: "Number_Of_Changes_Si",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "ACCESSORY ORDER-1",
      dataField: "Accessory_Order_1",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "ORDER DATE (AO)",
      dataField: "Order_Date_Ao_1",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
      formatter: formatDate,
    },
    {
      text: "ACCESSORY SET CODE",
      dataField: "Accessory_Set_Code_1",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "REQ ACC LINE-ON",
      dataField: "Req_Acc_Line_On_1",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "PROCESS (ACC)",
      dataField: "Process_Acc_1",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "ORDER CANCEL (AO)",
      dataField: "Order_Cancel_Ao_1",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "NO OF ACCESSORY ORDER",
      dataField: "Number_Of_Accessory_Order_1",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
      formatter : formatterStatus
    },
    {
      text: "ACCESSORY ORDER-2",
      dataField: "Accessory_Order_2",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "ORDER DATE (AO)",
      dataField: "Order_Date_Ao_2",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
      formatter: formatDate,
    },
    {
      text: "ACCESSORY SET CODE",
      dataField: "Accessory_Set_Code_2",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "REQ ACC LINE-ON",
      dataField: "Req_Acc_Line_On_2",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "PROCESS (ACC)",
      dataField: "Process_Acc_2",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "ORDER CANCEL (AO)",
      dataField: "Order_Cancel_Ao_2",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "NO OF ACCESSORY ORDER",
      dataField: "Number_Of_Accessory_Order_2",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
      formatter : formatterStatus

    },
    {
      text: "ACCESSORY ORDER-3",
      dataField: "Accessory_Order_3",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "ORDER DATE (AO)",
      dataField: "Order_Date_Ao_3",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
      formatter: formatDate,
    },
    {
      text: "ACCESSORY SET CODE",
      dataField: "Accessory_Set_Code_3",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "REQ ACC LINE-ON",
      dataField: "Req_Acc_Line_On_3",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "PROCESS (ACC)",
      dataField: "Process_Acc_3",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "ORDER CANCEL (AO)",
      dataField: "Order_Cancel_Ao_3",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "NO OF ACCESSORY ORDER",
      dataField: "Number_Of_Accessory_Order_3",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
      formatter : formatterStatus

    },
    {
      text: "ACCESSORY ORDER-4",
      dataField: "Accessory_Order_4",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "ORDER DATE (AO)",
      dataField: "Order_Date_Ao_4",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
      formatter: formatDate,
    },
    {
      text: "ACCESSORY SET CODE",
      dataField: "Accessory_Set_Code_4",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "REQ ACC LINE-ON",
      dataField: "Req_Acc_Line_On_4",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "PROCESS (ACC)",
      dataField: "Process_Acc_4",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "ORDER CANCEL (AO)",
      dataField: "Order_Cancel_Ao_4",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "NO OF ACCESSORY ORDER",
      dataField: "Number_Of_Accessory_Order_4",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
      formatter : formatterStatus

    },
    {
      text: "ACCESSORY ORDER-5",
      dataField: "Accessory_Order_5",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "ORDER DATE (AO)",
      dataField: "Order_Date_Ao_5",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
      formatter: formatDate,
    },
    {
      text: "ACCESSORY SET CODE",
      dataField: "Accessory_Set_Code_5",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "REQ ACC LINE-ON",
      dataField: "Req_Acc_Line_On_5",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "PROCESS (ACC)",
      dataField: "Process_Acc_5",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "ORDER CANCEL (AO)",
      dataField: "Order_Cancel_Ao_5",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "NO OF ACCESSORY ORDER",
      dataField: "No_Of_Accesory_Order",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
      formatter : formatterStatus

    },
    {
      text: "OWNERS GUIDE (PARTS NUMBER)",
      dataField: "Owners_Guide_Parts_Number",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "OWNERS GUIDE (CATEGORY)",
      dataField: "Owners_Guide_Category",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "ESTIMATED DATE / LINE-OFF",
      dataField: "Estimated_Date_Line_Off",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "ACTUAL DATE / LINE-OFF",
      dataField: "Actual_Date_Line_Off",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
      formatter: formatDate,
    },
    {
      text: "ETD FACTORY",
      dataField: "Etd_Factory",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
      formatter: formatDate,
    },
    {
      text: "ATD FACTORY",
      dataField: "Atd_Factory",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
      formatter: formatDate,

    },
    {
      text: "IMPORT COUNTRY CODE",
      dataField: "Import_Country_Code",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "IMPORT COUNTRY NAME",
      dataField: "Import_Country_Name",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "PORT OF LOADING",
      dataField: "Port_Of_Loading",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "ETD POL",
      dataField: "ETD_POL",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "ATD POL",
      dataField: "ATD_POL",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "PORT OF DISCHARGE",
      dataField: "Port_Of_Discharge2",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "ETA POD",
      dataField: "ETA_POD",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "ATA POD",
      dataField: "ATA_POD",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "EST / IMP CC",
      dataField: "Est_Imp_CC",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "ATD POD",
      dataField: "ATD_POD",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "ETA MP",
      dataField: "ETA_MP",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "ATA MP",
      dataField: "ATA_MP",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "PASSED / CII(1)",
      dataField: "Passed_CII_1",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "PROC / CII(1)",
      dataField: "Proc_CII_1",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "JUDGE / CII(1)",
      dataField: "Judge_CII_1",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "N/O / CII(1)",
      dataField: "N_O_CII_1",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "PASSED / CII(2)",
      dataField: "Passed_CII_2",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "PROC / CII(2)",
      dataField: "Proc_CII_2",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "JUDGE / CII(2)",
      dataField: "Judge_CII_2",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "N/O / CII(2)",
      dataField: "N_O_CII_2",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "EST / RCI",
      dataField: "Est_RCI",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "PASSED / RCI",
      dataField: "Passed / RCI",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
      formatter: formatDate,
    },
    {
      text: "PROC / RCI",
      dataField: "Proc / RCI",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
      formatter: formatDate,
    },
    {
      text: "JUDGE / RCI",
      dataField: "Judge / RCI",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "N/O / RCI",
      dataField: "N / O / RCI",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "ACT / RTN FACTORY",
      dataField: "Act / Rtn_Factory",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "REMARKS (RETURN TO FACTORY)",
      dataField: "Remarks(Return_To_Factory)",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "ESTIMATED DATE / RE-MP-IN",
      // dataField: "Est / ACC@I_L - ON",
      dataField: "Est Re-MP-IN",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
      formatter : formatDate
    },
    {
      text: "ACTUAL DATE / RE-MP-IN",
      // dataField: "Act / ACC@I_L - ON",
      dataField: "Act Re-MP-IN",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
      formatter : formatDate

    },
    {
      text: "EST / ACC@I L-ON",
      // dataField: "Est_ACCI_I",
      dataField: "Est / ACC@I_L - ON",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "ACT / ACC@I L-ON",
      // dataField: "Est_ACCI_I",
      dataField: "Act / ACC@I_L - ON",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "PASSED / ACCI@I",
      dataField: "Passed_ACCI_I",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "PROC / ACCI@I",
      dataField: "Proc_ACCI_I",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "JUDGE / ACCI@I",
      dataField: "Judge_ACCI_I",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "N/O / ACCI@I",
      dataField: "N_O_ACCI_I",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "EST / PDI@I",
      dataField: "EST / PDI@I",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
      formatter: formatDate
    },
    {
      text: "PASSED / PDI@I",
      dataField: "PASSED / PDI@I",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
      formatter: formatDate

    },
    {
      text: "PROC / PDI@I",
      dataField: "PROC / PDI@I",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
      formatter: formatDate

    },
    {
      text: "JUDGE / PDI@I",
      dataField: "JUDGE / PDI@I",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "N/O PDI@I",
      dataField: "N / OPDI@I",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "EST / STRG(TF-OUT@I)",
      dataField: "Est_STRG_TF_OUT_I",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "ACT / STRG(TF-OUT@I)",
      dataField: "Act_STRG_TF_OUT_I",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "EST / PICK(TF-OUT@I)",
      dataField: "Est_PICK_TF_OUT_I",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "ACT / PICK(TF-OUT@I)",
      dataField: "Act_PICK_TF_OUT_I",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "EST / TFOI@I",
      dataField: "Est_TFOI_I",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "PASSED / TFOI@I",
      dataField: "Passed_TFOI_I",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "PROC / TFOI@I",
      dataField: "Proc_TFOI_I",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "JUDGE / TFOI@I",
      dataField: "Judge_TFOI_I",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "N/O TFOI@I",
      dataField: "N_O_TFOI_I",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "ACT / TF STBY-1@I",
      dataField: "Act_TF_STBY_1_I",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "ACT / TF STBY-2@I",
      dataField: "Act_TF_STBY_2_I",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "ETD MP(TF-OUT@I)",
      dataField: "ETD_MP_TF_OUT_I",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "ATD MP(TF-OUT@I)",
      dataField: "ATD_MP_TF_OUT_I",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "PASSED / LDI(TF-OUT@I)",
      dataField: "Passed_LDI_TF_OUT_I",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "PROC / LDI(TF-OUT@I)",
      dataField: "Proc_LDI_TF_OUT_I",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "JUDGE / LDI(TF-OUT@I)",
      dataField: "Judge_LDI_TF_OUT_I",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "N/O LDI(TF-OUT@I)",
      dataField: "N_O_LDI_TF_OUT_I",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "ETA / MP-IN(TF-IN@I)",
      dataField: "ETA_MP_IN_TF_IN_I",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "ATA / MP-IN(TF-IN@I)",
      dataField: "ATA_MP_IN_TF_IN_I",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "EST / TFII@I",
      dataField: "Est_TFII_I",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "PASSED / TFII@I",
      dataField: "Passed_TFII_I",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "PROC / TFII@I",
      dataField: "Proc_TFII_I",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "JUDGE / TFII@I",
      dataField: "Judge_TFII_I",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "N/O TFII@I",
      dataField: "N_O_TFII_I",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "EST / MP-IN(TF-IN@I)",
      dataField: "Est_MP_IN_TF_IN_I",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "ACT / MP-IN(TF-IN@I)",
      dataField: "Act_MP_IN_TF_IN_I",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "ESTIMATED DATE / STORAGE",
      dataField: "Estimated_Date / Storage",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
      formatter: formatDate
    },
    {
      text: "ACTUAL DATE / STORAGE",
      dataField: "Actual_Date / Storage",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
      formatter: formatDate
    },
    {
      text: "PPTY(TF)",
      dataField: "PPTY_TF",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "PPTY(DP)",
      dataField: "PPTY_DP",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "EST / PICK ACC&PDI@S",
      dataField: "Est_PICK_ACC_PDI_S",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "ACT / PICK ACC&PDI@S",
      dataField: "Act_PICK_ACC_PDI_S",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "EST / ACC LINE-ON@S",
      dataField: "Est_ACC_LINE_ON_S",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "ACT / ACC LINE-ON@S",
      dataField: "Act_ACC_LINE_ON_S",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "EST / ACCI@S",
      dataField: "Est_ACCI_S",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "PASSED / ACCI@S",
      dataField: "Passed_ACCI_S",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "PROC / ACCI@S",
      dataField: "Proc_ACCI_S",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "EST / PICK PM",
      dataField: "Est / Pick_Pm",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
      formatter: formatDate
    },
    {
      text: "ACT / PICK PM",
      dataField: "Act / Pick_Pm",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
      formatter: formatDate
    },
    {
      text: "EST / PICK PM",
      dataField: "Est / Pick_Pm_PDIOUT",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
      formatter: formatDate
    },
    {
      text: "PASSED / PM",
      dataField: "Passed / Pm",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "PROC / PM",
      dataField: "Proc / Pm",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "JUDGE / PM",
      dataField: "Judge / Pm",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "N/O PM",
      dataField: "N / O Pn",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "EST / PICK PRRI",
      dataField: "Est / Pick_Prri",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
      formatter: formatDate
    },
    {
      text: "ACT / PICK PRRI",
      dataField: "Act / Pick_Prri",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
      formatter: formatDate
    },
    {
      text: "EST / PRRI",
      dataField: "Est / Prri",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
      formatter: formatDate
    },
    {
      text: "PASSED / PRRI",
      dataField: "Passed / Prri",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
      formatter: formatDate
    },
    {
      text: "PROC / PRRI",
      dataField: "Proc / Prri",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
      formatter: formatDate
    },
    {
      text: "JUDGE / PRRI",
      dataField: "Judge / Prri",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "N/O PRRI",
      dataField: "N / O_Prri",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "EST / PICK IRRI",
      dataField: "Est_PICK_IRRI",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "ACT / PICK IRRI",
      dataField: "Act_PICK_IRRI",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "EST / IRRI",
      dataField: "Est_IRRI",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "PASSED / IRRI",
      dataField: "Passed_IRRI",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "PROC / IRRI",
      dataField: "Proc_IRRI",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "JUDGE / IRRI",
      dataField: "Judge_IRRI",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "N/O IRRI",
      dataField: "N_O_IRRI",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "EST / SLOW",
      dataField: "Est_SLOW",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "ACT / SLOW",
      dataField: "Act_SLOW",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "EST / PICK(TF-OUT)",
      dataField: "Est_PICK_TF_OUT",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "ACT / PICK(TF-OUT)",
      dataField: "Act_PICK_TF_OUT",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "EST / TFOI",
      dataField: "Est_TFOI",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "PASSED / TFOI",
      dataField: "Passed_TFOI",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "PROC / TFOI",
      dataField: "Proc_TFOI",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "JUDGE / TFOI",
      dataField: "Judge_TFOI",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "N/O TFOI",
      dataField: "N_O_TFOI",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "ACT / TF STBY-1",
      dataField: "Act_TF_STBY_1",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "ACT / TF STBY-2",
      dataField: "Act_TF_STBY_2",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "ETD MP / TRANSFER-OUT",
      dataField: "ETD_MP_TRANSFER_OUT",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "ATD MP / TRANSFER-OUT",
      dataField: "ATD_MP_TRANSFER_OUT",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "PASSED / LDI(TF-OUT)",
      dataField: "Passed_LDI_TF_OUT",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "PROC / LDI(TF-OUT)",
      dataField: "Proc_LDI_TF_OUT",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "JUDGE / LDI(TF-OUT)",
      dataField: "Judge_LDI_TF_OUT",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "N/O LDI(TF-OUT)",
      dataField: "N_O_LDI_TF_OUT",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "ETA MP / TRANSFER-IN",
      dataField: "ETA_MP_TRANSFER_IN",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "ATA MP / TRANSFER-IN",
      dataField: "ATA_MP_TRANSFER_IN",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "EST / TFII",
      dataField: "Est_TFII",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "PASSED / TFII",
      dataField: "Passed_TFII",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "PROC / TFII",
      dataField: "Proc_TFII",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "JUDGE / TFII",
      dataField: "Judge_TFII",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "N/O TFII",
      dataField: "N_O_TFII",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "EST / MP-IN(TF-IN)",
      dataField: "Est_MP_IN_TF_IN",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "ACT / MP-IN(TF-IN)",
      dataField: "Act_MP_IN_TF_IN",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "EST / PICK(DP)",
      dataField: "Est_PICK_DP",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "ACT / PICK(DP)",
      dataField: "ACT / PICK(DP)",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "EST / PDI",
      dataField: "Est_PDI",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "PASSED / PDI",
      dataField: "Passed_PDI",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "PROC / PDI",
      dataField: "Proc_PDI",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "JUDGE / PDI",
      dataField: "Judge_PDI",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "N/O PDI",
      dataField: "N_O_PDI",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "ACT / DP STBY-1",
      dataField: "ACT / DP_STBY - 1",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "ACT / DP STBY-2",
      dataField: "Act_DP_STBY_2",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "PASSED / LDI",
      dataField: "Passed_LDI",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "PROC / LDI",
      dataField: "Proc_LDI",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "JUDGE / LDI",
      dataField: "Judge_LDI",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "N/O LDI",
      dataField: "N_O_LDI",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "TRANSIT POINT #1",
      dataField: "Transit_Point_1",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "ATA TRANSIT POINT #1",
      dataField: "ATA_Transit_Point_1",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "ATD TRANSIT POINT #1",
      dataField: "ATD_Transit_Point_1",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "TRANSIT POINT #2",
      dataField: "Transit_Point_2",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "ATA TRANSIT POINT #2",
      dataField: "ATA_Transit_Point_2",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "ATD TRANSIT POINT #2",
      dataField: "ATD_Transit_Point_2",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "C/L (TRANSPORT)",
      dataField: "C_L_Transport",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "EXP CC (E)",
      dataField: "EXP_CC_E",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "EXP CC (A)",
      dataField: "EXP_CC_A",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "ETD PORT OF LOADING",
      dataField: "ETD_Port_Of_Loading",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "ATD PORT OF LOADING",
      dataField: "ATD_Port_Of_Loading",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
  ];

  const options = {
    page: page < 0 ? 1 : page,
    sizePerPage: sizePerPage,
    showTotal: true,
    totalSize: totalSize,
    sizePerPageList: sizePerPageList(totalSize),
  };

  return (
    <>
      <BootstrapTable
        remote
        wrapperClasses="table-responsive"
        classes="table table-head-custom table-vertical-center overflow-hidden rounded mt-4"
        bootstrap4
        
        keyField="no"
        data={tableData}
        columns={columns}
        pagination={paginationFactory(options)}
        onTableChange={onTableChange}
        sort={{ dataField: sortField, order: sortOrder }}
        hover
        striped
        noDataIndication="No data to display.   Please do searching to display particular vehicle(s)"
      >
        <PleaseWaitMessage entities={loading ? null : tableData} />
        <NoRecordsFoundMessage entities={loading ? null : tableData} />
      </BootstrapTable>
    </>
  );
};
